import {
  useDialogDescription
} from "./YSASCXX3.js";
import {
  createComponent,
  createElement,
  createHook
} from "./NQJBHION.js";

// src/popover/popover-description.ts
var usePopoverDescription = createHook(
  (props) => {
    props = useDialogDescription(props);
    return props;
  }
);
var PopoverDescription = createComponent(
  (props) => {
    const htmlProps = usePopoverDescription(props);
    return createElement("p", htmlProps);
  }
);
if (process.env.NODE_ENV !== "production") {
  PopoverDescription.displayName = "PopoverDescription";
}

export {
  usePopoverDescription,
  PopoverDescription
};
